import type { Components } from '@mui/material/styles'
import { CheckCircle as CheckCircleIcon } from '@phosphor-icons/react/dist/ssr/CheckCircle'
import { Info as InfoIcon } from '@phosphor-icons/react/dist/ssr/Info'
import { Warning as WarningIcon } from '@phosphor-icons/react/dist/ssr/Warning'
import { WarningCircle as WarningCircleIcon } from '@phosphor-icons/react/dist/ssr/WarningCircle'

import type { Theme } from '../types'

export const MuiAlert = {
	defaultProps: {
		iconMapping: {
			error: <WarningCircleIcon />,
			warning: <WarningIcon />,
			info: <InfoIcon />,
			success: <CheckCircleIcon />,
		},
	},
	styleOverrides: {
		root: ({ theme }) => ({
			alignItems: 'center',
			[theme.breakpoints.down('sm')]: {
				'&.MuiAlert-root:has(.MuiAlert-action)': {
					position: 'relative',
					flexDirection: 'column',
					alignItems: 'flex-start',
					justifyContent: 'flex-start',
					'& .MuiAlert-action': {
						margin: 0,
						padding: 0,
					},
					'& .MuiAlert-action [aria-label="close"]': {
						position: 'absolute',
						top: 5,
						right: 5,
					},
				},
			},
		}),
		message: {
			fontWeight: 500,
		},
		icon: {
			fontSize: 'var(--icon-fontSize-md)',
			marginRight: '10px',
		},
	},
} satisfies Components<Theme>['MuiAlert']
